
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiArrowBidirectionalDiagonal as ObiArrowBidirectionalDiagonalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-arrow-bidirectional-diagonal.js';
 
 
 

 
 export const ObiArrowBidirectionalDiagonal = createComponent({
   react: React,
   tagName: 'obi-arrow-bidirectional-diagonal',
   elementClass: ObiArrowBidirectionalDiagonalElement,
   events: {
     
   }
  });
 
 